import React from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ArticleDetailContent = ({ article }) => {
  if (article.content)
    return (
      <Card>
        <Card.Body>
          <span
            dangerouslySetInnerHTML={{
              __html: article.content
            }}
          />
        </Card.Body>
      </Card>
    );
  else {
    return <></>;
  }
};
ArticleDetailContent.propTypes = {
  article: PropTypes.object
};
export default ArticleDetailContent;
